export const IncidentReportsPageTabs = {
  TABLE: 'ir_table',
  MONTHLY: 'ir_monthly',
  PIE_CHART: 'ir_pie_chart',
}